import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import OfertaSmartPhones from '@loyal_images/ofertas-smartphones.png'
import OfertaSmartPhonesMobile from '@loyal_images/ofertas-smartphones-mobile.png'
import OfertaTVs from '@loyal_images/ofertas-tvs.png'
import OfertaTVsMobile from '@loyal_images/ofertas-tvs-mobile.png'
import OfertaEletroportateis from '@loyal_images/ofertas-eletroportateis.png'
import OfertaEletroportateisMobile from '@loyal_images/ofertas-eletroportateis-mobile.png'
import OfertaUtilidadesDomesticas from '@loyal_images/ofertas-utilidades-domesticas.png'
import OfertaUtilidadesDomesticasMobile from '@loyal_images/ofertas-utilidades-domesticas-mobile.png'
import OfertaInfantilBebes from '@loyal_images/ofertas-infantil-e-bebes.png'
import OfertaInfantilBebesMobile from '@loyal_images/ofertas-infantil-e-bebes-mobile.png'
import OfertaEletrodomesticos from '@loyal_images/ofertas-eletrodomesticos.png'
import OfertaEletrodomesticosMobile from '@loyal_images/ofertas-eletrodomesticos-mobile.png'

class BestOffers extends Component {
  constructor (props) {
    super(props)

    this.state = {}
  }

  render () {
    return (
      <div className='pos-relative pb-3 px-1 scope-points'>
        <div className='container px-0'>
          <div className='row'>
            <div className='col-12 mb-2'>
              <h2 className='txt-font-title color-title d-none d-md-block'>As melhores ofertas por categoria.</h2>
              <h2 className='txt-font-title color-title d-block d-md-none'>Ofertas por categoria.</h2>
            </div>
            <div className='col-6 col-md-4 mb-2'>
              <Link to='/search?term=Smartphone&subcategory=48' className='d-block'>
                <img src={OfertaSmartPhones} className='d-none d-md-block w-100' alt='Busque por Smartphones' />
                <img src={OfertaSmartPhonesMobile} className='d-block d-md-none w-100' alt='Busque por Smartphones' />
              </Link>
            </div>
            <div className='col-6 col-md-4 mb-2'>
              <Link to='/search?subcategory=46' className='d-block'>
                <img src={OfertaTVs} className='d-none d-md-block w-100' alt='Busque por TVs' />
                <img src={OfertaTVsMobile} className='d-block d-md-none w-100' alt='Busque por TVs' />
              </Link>
            </div>
            <div className='col-6 col-md-4 mb-2'>
              <Link to='/search?subcategory=39' className='d-block'>
                <img src={OfertaEletroportateis} className='d-none d-md-block w-100' alt='Busque por Elétroportáteis' />
                <img src={OfertaEletroportateisMobile} className='d-block d-md-none w-100' alt='Busque por Elétroportáteis' />
              </Link>
            </div>
            <div className='col-6 col-md-4 mb-2'>
              <Link to='/search?subcategory=42' className='d-block'>
                <img src={OfertaUtilidadesDomesticas} className='d-none d-md-block w-100' alt='Busque por Utilidades Domésticas' />
                <img src={OfertaUtilidadesDomesticasMobile} className='d-block d-md-none w-100' alt='Busque por Utilidades Domésticas' />
              </Link>
            </div>
            <div className='col-6 col-md-4 mb-2'>
              <Link to='/search?category=3' className='d-block'>
                <img src={OfertaInfantilBebes} className='d-none d-md-block w-100' alt='Busque por Infantil e Bebês' />
                <img src={OfertaInfantilBebesMobile} className='d-block d-md-none w-100' alt='Busque por Infantil e Bebês' />
              </Link>
            </div>
            <div className='col-6 col-md-4 mb-2'>
              <Link to='/search?subcategory=38' className='d-block'>
                <img src={OfertaEletrodomesticos} className='d-none d-md-block w-100' alt='Busque por Elétrodomésticos' />
                <img src={OfertaEletrodomesticosMobile} className='d-block d-md-none w-100' alt='Busque por Elétrodomésticos' />
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BestOffers



// WEBPACK FOOTER //
// ./src/features/BestOffers/BestOffers.js